<div style="width: 900px; margin: 0 auto;  border-radius: 12px" ngStyle.lt-lg="width: 90%">
  <div class="back-holder" routerLink="/profile">
    <div class="back">
      <mat-icon style="margin-right: 4px; color: #29314A">keyboard_backspace</mat-icon>
    </div>
    <span style="margin-right: 5px; outline: none; color: #29314A;  font-size: 14px">Go back to profile</span>
    <!--    <mat-icon>keyboard_arrow_right</mat-icon>-->
    <!--    <span style="margin-left: 5px; outline: none;">{{reactiveForm.get('email').value}}</span>-->
  </div>
  <mat-card>
    <div>
      <h4 style="margin-top: 0">My profile</h4>
      <div style="border: 1px solid #e6e6e6; padding: 20px; border-radius: 4px; display: flex; justify-content: space-between; margin-bottom: 20px">
        <div style="display: flex; flex-direction: column">
          <h4 style="margin-top: 0">Avatar</h4>
          <input type="file" accept="image/jpeg,image/jpg,image/png,image/svg" (change)="fileSelect($event)">
          <button mat-button style="background: #0a1c40; color: white; width: fit-content; margin-top: 10px" (click)="uploadAvatar()">Upload
          </button>
        </div>
        <div style="width: 100px; height: 100px" *ngIf="user && user.headerUrl">
          <img src="{{SERVER_URL}}images{{user.headerUrl}}" style="width: 100%; height: 100%;  border-radius: 100px">
        </div>

      </div>
      <form [formGroup]="reactiveForm">
        <div style="display: flex; justify-content: space-between">
          <mat-form-field style="width: 45%" appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" [disabled]="true">
          </mat-form-field>
          <mat-form-field style="width: 45%" appearance="outline">
            <mat-label>Phone</mat-label>
            <input matInput formControlName="phone">
          </mat-form-field>
        </div>
        <mat-form-field style="width: 45%" appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput formControlName="password">
        </mat-form-field>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field style="width: 45%" appearance="outline">
            <mat-label>First name</mat-label>
            <input matInput formControlName="firstName">
          </mat-form-field>
          <mat-form-field style="width: 45%" appearance="outline">
            <mat-label>Last name</mat-label>
            <input matInput formControlName="lastName">
          </mat-form-field>
        </div>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field style="width: 45%" appearance="outline">
            <mat-label>Role</mat-label>
            <mat-select formControlName="role">
              <mat-option [value]=3>Developer admin</mat-option>
              <mat-option [value]=4>Developer manager</mat-option>
              <mat-option [value]=5>Developer operator</mat-option>
            </mat-select>
          </mat-form-field>
          <!--          <mat-form-field style="width: 45%" appearance="outline">-->
          <!--            <mat-label>Status</mat-label>-->
          <!--            <mat-select formControlName="status">-->
          <!--              <mat-option [value]=1>Activated</mat-option>-->
          <!--              <mat-option [value]=0>Deactivated</mat-option>-->
          <!--            </mat-select>-->
          <!--          </mat-form-field>-->
        </div>
        <div style="display: flex; justify-content: flex-end">
          <button mat-button style="background: #21a037; color: white" (click)="editUser()">
            Update
          </button>
        </div>


      </form>

    </div>
  </mat-card>
</div>